import React from "react";
import PropTypes from "prop-types";
import ImmutablePropTypes from "react-immutable-proptypes";
import debounce from "debounce";
import logger from "lib/log";

import { history } from "state/history";

import Carousel from "components/Carousel";

import "./EntityCarousel.css";

// debounce period of resize event hanlder in ms
const RESIZE_DEBOUNCE_DELAY = 200;

/**
 * Manually set the CSS height of every swiper slide.
 * This is legacy support for older versions of iOS which have
 *   trouble shrinking the slides down to the height of the container.
 * We attach this to swiper's "resize" event, as well as "init" so
 *   that it runs at least once.
 */
function setSwiperSlideHeight() {
  const containerHeight = this.el.clientHeight;
  this.slides.each((_, slide) => {
    slide.style.height = containerHeight + "px";
  });
}

/**
 * Allow swiping between schools'/students' pages.
 */
export default class EntityCarousel extends React.Component {
  
  static getDerivedStateFromProps(nextProps, state) {
    if(!nextProps.entityIDList.equals( state.entityIDList ) ){
      logger.debug("EntityCarousel: entityIDList has updated, re-rendering...")
      return {
          entityIDList: nextProps.entityIDList,
          renderedChildren: EntityCarousel.renderChildren(nextProps)
      }
    } else {
      return null;
    }

  }

  state = {
    entityIDList: null,
    renderedChildren: null
  }
  
  static renderChildren (props) {
    return props.entityIDList.map(entityID => props.children(entityID)).toArray();
  }
  
  static propTypes = {
    entityIDList: ImmutablePropTypes.listOf(PropTypes.any).isRequired,
    generatePath: PropTypes.func.isRequired,
    activeEntityID: PropTypes.any,
    children: PropTypes.func.isRequired,
    onChange: PropTypes.func
  }
  
  changeEntity = (activeIndex, prevActiveIndex) => {
    const entityID = this.props.entityIDList.get(activeIndex);
    history.push(this.props.generatePath(entityID));
    if (this.props.onChange !== undefined) {
      const prevEntityID = this.props.entityIDList.get(prevActiveIndex);
      this.props.onChange(entityID, prevEntityID);
    }
  }
  
  getActiveIndex() {
    return this.props.entityIDList.indexOf(this.props.activeEntityID);
  }
  
  getSwiperOptions() {
    return {
      // disable swiper when there is only a single slide
      watchOverflow: true,
      // default to active entity
      initialSlide: this.getActiveIndex(),
      // support vertical scrolling on older iOS
      on: {
        init: setSwiperSlideHeight,
        resize: debounce(setSwiperSlideHeight, RESIZE_DEBOUNCE_DELAY)
      }
    }
  }
  
  render() {
    return (
      <Carousel
        cssBlockName="entity-carousel"
        swiperOptions={this.getSwiperOptions()}
        activeIndex={this.getActiveIndex()}
        onAfterChange={this.changeEntity}
      >
      {this.state.renderedChildren}
      </Carousel>
    );
  }
  
}



// WEBPACK FOOTER //
// ./src/components/EntityCarousel.js